"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = exports.RadioButtons = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("./icon"));

require("../css/radio_button.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RadioButtons =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RadioButtons, _React$Component);

  function RadioButtons(props) {
    var _this;

    _classCallCheck(this, RadioButtons);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RadioButtons).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (index, value) {
      _this.setState({
        selectedIndex: index
      });

      if (_this.props.onChange) {
        _this.props.onChange(index, value);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "prepareChildren", function () {
      var children = [];

      _react.default.Children.forEach(_this.props.children, function (child, index) {
        children.push(_react.default.cloneElement(child, {
          checked: index === _this.state.selectedIndex,
          index: index,
          name: _this.props.name,
          onChange: _this.handleChange,
          // eslint-disable-next-line react/no-array-index-key
          key: index
        }));
      });

      return children;
    });

    _this.state = {
      selectedIndex: props.selectedIndex
    };
    return _this;
  }

  _createClass(RadioButtons, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var selectedIndex = this.props.selectedIndex;

      if (selectedIndex !== nextProps.selectedIndex) {
        this.setState({
          selectedIndex: nextProps.selectedIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.prepareChildren();

      var _this$props = this.props,
          alignment = _this$props.alignment,
          className = _this$props.className,
          onChange = _this$props.onChange,
          selectedIndex = _this$props.selectedIndex,
          name = _this$props.name,
          remainingProps = _objectWithoutProperties(_this$props, ["alignment", "className", "onChange", "selectedIndex", "name"]);

      var classes = (0, _classnames.default)('vn-radio-buttons', className);
      return _react.default.createElement("div", _extends({
        role: "radiogroup",
        "aria-label": name
      }, remainingProps, {
        className: (0, _classnames.default)(classes)
      }), children.map(function (item) {
        return _react.default.createElement("div", {
          key: item.key,
          className: "vn-radio-buttons__item--alignment-".concat(alignment)
        }, item);
      }));
    }
  }]);

  return RadioButtons;
}(_react.default.Component);

exports.RadioButtons = RadioButtons;
RadioButtons.propTypes = {
  alignment: _propTypes.default.oneOf(['horizontal', 'vertical']),
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  selectedIndex: _propTypes.default.number
};
RadioButtons.defaultProps = {
  alignment: 'vertical',
  className: null,
  onChange: function onChange() {},
  selectedIndex: -1
};
/*----------------------------------------------------------------------------------------------*/

var RadioButton = function RadioButton(_ref) {
  var _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      index = _ref.index,
      label = _ref.label,
      onChange = _ref.onChange,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["checked", "disabled", "index", "label", "onChange", "value"]);

  var handleChange = function handleChange() {
    if (disabled) {
      return;
    }

    if (onChange) {
      onChange(index, value);
    }
  };

  var className = props.className,
      id = props.id,
      remainingProps = _objectWithoutProperties(props, ["className", "id"]);

  var labelClasses = {
    'vn-radio-button-box': true,
    'vn-radio-button-box--disabled': disabled
  };

  if (className) {
    labelClasses[className] = true;
  }

  var iconClasses = {
    'vn-radio-button-box__icon': true,
    'vn-radio-button-box__icon--checked': checked,
    'vn-radio-button-box__icon--disabled': disabled
  };

  var icon = _react.default.createElement(_icon.default, {
    name: "circle",
    className: (0, _classnames.default)(iconClasses)
  });

  var labelText;

  if (label) {
    labelText = _react.default.createElement("span", {
      className: "vn-radio-button-box__span-text"
    }, label);
  }

  return _react.default.createElement("label", {
    className: (0, _classnames.default)(labelClasses),
    htmlFor: id
  }, _react.default.createElement("input", _extends({}, remainingProps, {
    id: id,
    className: "vn-radio-button-box__input",
    onChange: handleChange,
    checked: checked,
    type: "radio",
    disabled: disabled
  })), icon, labelText);
};

exports.RadioButton = RadioButton;
RadioButton.propTypes = {
  checked: _propTypes.default.bool,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  id: _propTypes.default.string,
  index: _propTypes.default.number.isRequired,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  onChange: _propTypes.default.func,
  value: _propTypes.default.string
};
RadioButton.defaultProps = {
  checked: false,
  className: null,
  disabled: false,
  id: null,
  label: null,
  onChange: undefined,
  value: undefined
};
RadioButtons.displayName = 'RadioButtons';
RadioButton.displayName = 'RadioButton';
var _default = RadioButtons;
exports.default = _default;